import React from 'react';
import styled from 'styled-components';
const StyledHeader = styled.div `
	display: flex;
	align-items: center;
	justify-content: center;
	height: 120px;
	background: rgba(236, 216, 152, 0.7);
	font-size: 30px;
`;
const StyledPoints = styled.div `
	display: inline-block;
	width: 2.46em;
	height: 2.46em;
	border-radius: 50%;
	background-color: #ecd898;
	color: #fff;
	font-weight: bold;
	line-height: 2.46em;
	text-align: center;
`;
const DialogHeader = ({ points, }) => (React.createElement(StyledHeader, null,
    React.createElement(StyledPoints, null, points)));
export default DialogHeader;
